var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadioButtonInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19995 0.25C3.9187 0.25 0.449951 3.71875 0.449951 8C0.449951 12.2812 3.9187 15.75 8.19995 15.75C12.4812 15.75 15.95 12.2812 15.95 8C15.95 3.71875 12.4812 0.25 8.19995 0.25ZM8.19995 14.25C4.74683 14.25 1.94995 11.4531 1.94995 8C1.94995 4.54688 4.74683 1.75 8.19995 1.75C11.6531 1.75 14.45 4.54688 14.45 8C14.45 11.4531 11.6531 14.25 8.19995 14.25Z",
    fill: "#727781"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioButtonInactive);
export default __webpack_public_path__ + "static/media/radio_button_inactive.12a76416.svg";
export { ForwardRef as ReactComponent };